import { BLOCK_REGISTRY } from "../blockRegistry";

const ABOUT_COURSES_MASTHEAD_DEFAULT_BLOCKS = [
  { id: "default-about-courses-carousel", type: "about-courses-carousel" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default ABOUT_COURSES_MASTHEAD_DEFAULT_BLOCKS;
